export const getAllProviders = state =>
    state.primaryShippingProviders.concat(state.secondaryShippingProviders);

export const getAllProducts = state =>
    getAllProviders(state).flatMap(provider => provider.products);

const getAllVariants = state =>
    getAllProducts(state).flatMap(({ variants }) => variants);

export const getPrimaryOrSecondaryProducts = (state, onlyPrimary) =>
    (onlyPrimary
        ? state.primaryShippingProviders
        : state.secondaryShippingProviders
    ).flatMap(provider => provider.products);

export const getSelectedProduct = (state, onlyPrimary) =>
    getPrimaryOrSecondaryProducts(state, onlyPrimary).find(
        ({ selected }) => selected === true
    );

export const getVariant = (state, { type, productId }) =>
    getAllVariants(state).find(
        variant => variant.type === type && variant.id === productId
    );

export const getSelectedShippingProducts = (
    shippingByWeight,
    selectedShippingOptions,
    offerTakeaway
) => {
    const result = selectedShippingOptions.map(selected => {
        const shippingOption = shippingByWeight
            .flatMap(options => options.products)
            .find(
                product =>
                    product.providerId === selected.type &&
                    product.weight === selected.weight &&
                    product.id === selected.productId
            );
        return shippingOption
            ? {
                  ...shippingOption,
                  cost: selected?.cost
              }
            : null;
    });

    const possiblePosten = selectedShippingOptions.find(
        shippingOption => shippingOption.type === 'Posten'
    );

    if (possiblePosten) {
        result.push({
            ...possiblePosten,
            productId: possiblePosten.type,
            providerId: possiblePosten.type,
            price: possiblePosten.cost
        });
    }

    if (offerTakeaway) {
        const takeAwayOption =
            result.length === 0
                ? {
                      type: 'TakeawayOnly',
                      providerId: 'TakeawayOnly',
                      name: 'Endast avhämtning',
                      summaryDisplayName: 'Endast avhämtning'
                  }
                : {
                      type: 'Takeaway',
                      providerId: 'Takeaway',
                      name: 'Avhämtning',
                      summaryDisplayName: 'Avhämtning'
                  };
        result.push(takeAwayOption);
    }

    return result.filter(x => x !== null);
};
